/**
 * Labstep
 */

import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';

export const placeholder = `Select ${PurchaseOrder.getHumanReadableEntityName()} status`;
